export const environment = {
  baseUrl: 'https://api.dev.talebpretest.com',
};
